module.exports = {
          srcSet: __webpack_public_path__ + "images/1968-9ff8a6bc6843c3f7c9bfa41ef345d719-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1968-59bc240be60983e5dbd4a88a61014bd5-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1968-9ff8a6bc6843c3f7c9bfa41ef345d719-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1968-59bc240be60983e5dbd4a88a61014bd5-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1968-9ff8a6bc6843c3f7c9bfa41ef345d719-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1968-9ff8a6bc6843c3f7c9bfa41ef345d719-320.jpg"},
          
          width: 320,
          height: 251
        }